import { render } from "./ItemCarousel.vue?vue&type=template&id=97db1128&scoped=true"
import script from "./ItemCarousel.vue?vue&type=script&lang=js"
export * from "./ItemCarousel.vue?vue&type=script&lang=js"

import "./ItemCarousel.vue?vue&type=style&index=0&id=97db1128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97db1128"]])

export default __exports__